// import 'chart.js' // probably not required
global.erwingoApp = window.erwingoApp = {};

// global constant values
erwingoApp.EMPTYDATE = '0000-00-00';
erwingoApp.EMPTYDATETIME = '0000-00-00 00:00:00';


erwingoApp.options = {
    'url': url_api,
    'debug': 1,
    'requestCount': 0,
    'ajaxInitiator': typeof (ajaxInitiator) != 'undefined' ? ajaxInitiator : "frontend"
};
erwingoApp.loadingDialog = {
    start: function () {
        $('#loading').modal('show');

        $('#loadingClose').hide();
        $("#loadingConsole").empty();
        $("#progressStatusLabel").text(i18next.t('Uploading data...'));
    },
    progress: function (width, text) {
        $('#progress .progress-bar')
            .css('width', width + '%')
            .text(text);
        $("#progressStatusLabel").text(i18next.t('Data is being processed, which may take some time.\\n\\n Please wait...'));
    },
    console: function (append, nl) {
        if (typeof nl == 'undefined') {
            var nl = "\n";
        }
        $("#loadingConsole").append(append + nl);
        if ($("#loadingAutoScroll").prop("checked")) {
            var psconsole = $('#loadingConsole');
            psconsole.scrollTop(psconsole[0].scrollHeight - psconsole.height());
        }
    },
    stop: function () {
        $("#progressStatusLabel").text(i18next.t('Data has been uploaded and processed.'));
        $('#loadingClose').show();
            setTimeout(function () {
                $('#loading').modal('hide');
            }, 500);
    }
};
/**
 * Report a failed AJAX JSON parse to Sentry as a REAL Error (not a plain object).
 *
 * Passing a plain object to Sentry.captureException makes Sentry record a
 * "Non-Error exception captured with keys: ..." entry that cannot be grouped or acted
 * upon - this was the root cause of the TM-39 noise. Wrapping the failure in a proper
 * Error with a stable name + structured context restores grouping and keeps the report
 * actionable.
 *
 * Strategy chosen for TM-39: ALWAYS report (both empty and malformed bodies); the caller
 * decides how to recover (see options.onParseError in erwingoApp.ajax).
 *
 * @param {Error}  err         The error thrown by JSON.parse.
 * @param {string} rawResponse The raw, unparsed response body from the server.
 * @param {Object} requestData The request payload that was sent (action/module/cl etc.).
 * @returns {void}
 */
erwingoApp.reportJsonParseError = function (err, rawResponse, requestData) {
    // Wrap the failure in a real Error so Sentry can fingerprint and group it; a plain
    // object would be recorded as the unactionable "Non-Error exception" (TM-39).
    var error = new Error('AJAX response was not valid JSON: ' + (err && err.message));
    error.name = 'AjaxJsonParseError'; // stable name -> clean Sentry grouping

    var isStr = typeof rawResponse === 'string';
    Sentry.captureException(error, {
        extra: {
            request: requestData,
            // keep a short snippet only: the body may be a huge HTML error page
            responseSnippet: isStr ? rawResponse.slice(0, 500) : String(rawResponse),
            responseLength: isStr ? rawResponse.length : null,
        },
    });
};
erwingoApp.ajax = function (options, verbose) {
    // show loading indicator whenever a request is sent to the server
    // unless we hide it on purpose
    if (!options.ignoreLoadingIndicator == true) {
      erwingoApp.showLoadingIndicator()
    }

    var verbose = verbose || false;
    // console.log("JSON Request", options);
    options.data.initiator = erwingoApp.options.ajaxInitiator;
    var defaults = {
        url: options.url || url_api,
        type: "POST",
        data: options.data,
        success: function (json) {
            var data = null;
            try {
                data = JSON.parse(json);
            } catch (err) {
                // The server returned an empty or non-JSON body (e.g. a transient blip on a
                // backend auto-refresh). Report it as a real Error so Sentry can group it
                // (a plain object would be logged as a "Non-Error exception" - see TM-39),
                // then skip processing entirely so the caller's current UI is left intact
                // instead of being blanked. The caller may recover via options.onParseError
                // (e.g. keep an auto-refresh alive).
                erwingoApp.reportJsonParseError(err, json, options.data);
                if (typeof options.onParseError === "function") {
                    options.onParseError(err);
                }
                return;
            }

            if (options.longRunning !== true) {
              erwingoApp.processJsonResult(data, options);
            }

            if (typeof options.success !== "undefined" && options.success !== undefined && options.success !== null) {
                options.success(data);
            }
        },
        complete: function(result, status) {
          // hide loading indicator when response comes from server
          // unless we have a long-running operation
          if (options.longRunning !== true) {
            erwingoApp.hideLoadingIndicator()
          }

          if (typeof options.complete !== "undefined" && options.complete !== undefined && options.complete !== null) {
            options.complete(result, status);
          }
        }
    };
    // console.log(defaults);
    return $.ajax(defaults);
};
erwingoApp.calcHeight = function () {
    $(document).find(".calcHeight").each(function () {
        var maxHeight = $(this).height();
        $(this).children(".fixedHeight").each(function () {
            maxHeight = maxHeight - $(this).outerHeight(true);
        });
        $(this).children(".autoHeight").outerHeight(maxHeight);
    });
};
erwingoApp.destroyModules = function (target) {
    $(target).find('select:not([data-auto-complete]):not(.plain), select[data-auto-complete]').select2('destroy');
};
// Reload page if user got logged out
erwingoApp.checkUser = function (userType, timeout) {
    erwingoApp.ajax({
        data: {cl: "AccessControl", fnc: "checkLoginStatus", userType: userType},
        ignoreLoadingIndicator: true,
        success: function (response) {
            if (typeof user != "undefined" && response.active != user) {
                erwingoApp.autologout();
            } else {
                user = response.active;
            }
        }
    });
    return setTimeout(function () {
        erwingoApp.checkUser(userType, timeout);
    }, timeout);
};
erwingoApp.genText = function (html, options) {
    if (typeof html != 'undefined') {
        html = html.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
        $.each(options, function (key, value) {
            var regExpKey = new RegExp("\\@" + key + "\\@", "gi");
            html = html.replace(regExpKey, value);
        });
        $.each(options, function (key, value) {
            var regExpKey = new RegExp("\\{[\\$]*" + key + "\\}", "gi");
            html = html.replace(regExpKey, value);
        });
        var re = /<%([^%>]+)?%>/g, reExp = /(^( )?(if|for|else|switch|case|break|{|}))(.*)?/g, code = 'var r=[];\n',
            cursor = 0;
        var add = function (line, js) {
            js ? (code += line.match(reExp) ? line + '\n' : 'r.push(' + line + ');\n') :
                (code += line != '' ? 'r.push("' + line.replace(/"/g, '\\"') + '");\n' : '');
            return add;
        }
        while (match = re.exec(html)) {
            add(html.slice(cursor, match.index))(match[1], true);
            cursor = match.index + match[0].length;
        }
        add(html.substr(cursor, html.length - cursor));
        code += 'return r.join("");';
        return new Function(code.replace(/[\r\t\n]/g, '')).apply(options);
        return html;
    } else {
        return '...';
    }
};
erwingoApp.hashMe = function (obj) {
    if (obj == null || obj == undefined) {
        obj = "";
    }
    try {
        var hashable = obj;
        if (hashable.constructor.name != "String") {
            hashable = JSON.stringify(hashable);
        }
        var hash = 0, i, chr;
        if (hashable.length === 0) return hash;
        for (i = 0; i < hashable.length; i++) {
            chr = hashable.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
    } catch (err) {
        console.log(obj, err);
        var hash = erwingoApp.hashMe("");
    }
    return hash;
};
erwingoApp.translate = function (args) {
    if (typeof args == "string") {
        var key = args;
    } else if (args.key) {
        var key = args.key;
    }
    if (_LANG_[key]) {
        return _LANG_[key];
    } else {
        return "[No translation: '" + key + "']";
    }
};
erwingoApp.updateChart = function (chartElement) {
    var options = {
        module: '',
        cl: '',
        fnc: '',
        chart: '',
        search: '',
        config: {},
        filters: {}
    };
    var options = $.extend(true, options, chartElement.data());
    var searchElement = $('#' + options.search + 'search');
    var chartId = chartElement.attr('id');
    //convert jQuery object into a string
    var chartElementOrigin = chartElement.prop('outerHTML');
    var parent = chartElement.parent();
    var update = function () {
        erwingoApp.ajax({
            data: options,
            success: function (response) {
                $(document.getElementById(chartId)).replaceWith(chartElementOrigin);
                if (!$.isEmptyObject(response)) {
                    parent.find('#noResults').hide();
                    if (options.chart == 'plotly') {
                        var ctx = document.getElementById(chartId);
                        var layout = $.extend(response.layout, {
                            height: parent.hasClass('widget-body') ? parent.parent().height() : parent.height(),
                            width: parent.hasClass('widget-body') ? parent.parent().width() : parent.width()
                        });
                        Plotly.plot(ctx, response.plotly, layout, {
                            modeBarButtonsToRemove: ['sendDataToCloud'],
                            displaylogo: false
                        });
                        /*

                        //Bad solution!! Only works with Popups

                        parent.parent().parent().parent().resize(function() {
                            Plotly.relayout(ctx, {
                                width:parent.width(),
                                height:parent.height()
                            })
                        });

                        */
                        /*
                        //This solution is better, but only works with popups
                        var observer = new MutationObserver(function(mutations) {
                            mutations.forEach(function(mutationRecord) {
                                Plotly.relayout(ctx, {
                                    height:parent.hasClass('widget-body') ? parent.parent().height() : parent.height(),
                                    width:parent.hasClass('widget-body') ? parent.parent().width() : parent.width()
                                });
                            });
                        });

                        //parent.[0] -> native DOM element from a jQuery
                        var target = parent[0];
                        observer.observe(target, {attributes: true, attributeFilter: ['style']});
                        */
                        var disableObserver = false;
                        var observer = new MutationObserver(function (mutations) {
                            if (!disableObserver) {
                                if (mutations.length < 20) {
                                    mutations.forEach(function (mutation) {
                                        /*
                                        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                                            // element added to DOM
                                            if(mutation.addedNodes[0].id == 'gridster-stylesheet-#widgets'){

                                            }
                                        }
                                        */
                                        //console.log(mutation);
                                        if (mutation.addedNodes.length > 0) {
                                            setTimeout(function () {
                                                Plotly.relayout(ctx, {
                                                    height: parent.hasClass('widget-body') ? parent.parent().height() : parent.height(),
                                                    width: parent.hasClass('widget-body') ? parent.parent().width() : parent.width()
                                                });
                                            }, 200);
                                        } else {
                                            Plotly.relayout(ctx, {
                                                height: parent.hasClass('widget-body') ? parent.parent().height() : parent.height(),
                                                width: parent.hasClass('widget-body') ? parent.parent().width() : parent.width()
                                            });
                                        }
                                    });
                                }
                            }
                        });
                        var config = {
                            attributes: true,
                            childList: true,
                            characterData: true,
                            attributeFilter: ['style']
                        };
                        var target = parent.hasClass('widget-body') ? document.head : parent[0];
                        observer.observe(target, config);
                    } else if (options.chart === 'chart') {
                        var ctx = document.getElementById(chartId);
                        // var chart = new Chart (ctx,[response]);
                        var chart = new Chart(ctx, {
                            type: response.type,
                            data: response.chart,
                            options: response.options
                        });
                    }
                } else {
                    parent.find('#noResults').show();
                }
            }
        });
    };
    update();
    searchElement.find('[name]').on("change dp.change", function () {
        searchElement.closest('.widget').find('iframe').remove();
        searchElement.find('[name]').each(function () {
            options.filters[$(this).attr("name")] = $(this).val();
        });
        update();
    });
};
erwingoApp.contextMenu = function (options) {
    var contextMenuData = {};
    var contextMenuOptions = {
        selector: options.selector,
        build: function ($trigger, e) {
            // this callback is executed every time the menu is to be shown
            // its results are destroyed every time the menu is hidden
            // e is the original contextmenu event, containing e.pageX and e.pageY (amongst other data)
            return {
                zIndex: 999,
                //callback: function (key, opt) {},
                items: items,
                events: {
                    show: function (opt) {
                        // this is the trigger element
                        var $this = this;
                        // import states from data store
                        if (!$.isEmptyObject(closedWidgets) && $.isEmptyObject($this.data())) {
                            contextMenuData = $.contextMenu.getInputValues(opt, $this.data());
                            mergeContextData();
                        }
                        if (!$.isEmptyObject($this.data())) {
                            mergeContextData();
                            $.contextMenu.setInputValues(opt, $this.data());
                            // this basically fills the input commands from an object
                            // like {name: "foo", yesno: true, radio: "3", &hellip;}
                        }
                    },
                    hide: function (opt) {
                        // this is the trigger element
                        var $this = this;
                        // export states to data store
                        contextMenuData = $.contextMenu.getInputValues(opt, $this.data());
                        // this basically dumps the input commands' values to an object
                        // like {name: "foo", yesno: true, radio: "3", &hellip;}
                    },
                }
            };
        }
    };

    function mergeContextData() {
        contextMenuData = $.extend(contextMenuData, closedWidgets);
    }

    var items = {};
    erwingoApp.ajax({
        data: {
            module: "erwingo",
            cl: "FormAdmin",
            fnc: "getContextData",
        },
        success: function (response) {
            processItems(response);
            $.contextMenu(contextMenuOptions);
        }
    });

    function processItems(param) {
        param.forEach(function (key) {
            var label = Object.keys(key)[0];
            if (label == 'widgets') {
                key = key[label];
                label = Object.keys(key)[0];
                for (k in key) {
                    for (item in key[k]['items']) {
                        if (item == "save") {
                            key[k]['items'][item]['callback'] = function (itemKey, opt) {
                                var data = [];
                                var counter = 0;
                                var col = 1;
                                var row = 1;
                                var openWidgets = [];
                                var closeWidgets = [];
                                $.each(opt.inputs, function (key, item) {
                                    if (item.type == "checkbox") {
                                        const res = item.$input.val().split(':');
                                        const widgetId = res[0];
                                        if (item.$input.prop('checked')) {
                                            const x = parseInt(res[1]);
                                            const y = parseInt(res[2]);
                                            openWidgets.push(widgetId);
                                            counter += x;
                                            if (counter <= 6) {
                                                data.push(widgetId + ':' + col + ':' + row + ':' + x + ':' + y)
                                            } else {
                                                row += 1;
                                                counter = x;
                                                col = 1;
                                                data.push(widgetId + ':' + col + ':' + row + ':' + x + ':' + y)
                                            }
                                            col += x;
                                        } else {
                                            closeWidgets.push(widgetId);
                                        }
                                    }
                                });
                                erwingoApp.ajax({
                                    data: {
                                        module: "erwingo",
                                        cl: "FormAdmin",
                                        fnc: "updateWidgetsContextMenu",
                                        widgetData: data,
                                    },
                                    success: function (response) {
                                        //window.location.reload();
                                        closeWidgets.forEach(function (widget) {
                                            var thisWidget = $('#widget-select-list').find('[name="' + widget + '"]');
                                            if (thisWidget.is(':checked')) {
                                                thisWidget.prop('checked', false).trigger('change');
                                            }
                                        });
                                        openWidgets.forEach(function (widget) {
                                            var thisWidget = $('#widget-select-list').find('[name="' + widget + '"]');
                                            if (!thisWidget.is(':checked')) {
                                                thisWidget.prop('checked', true).trigger('change');
                                            }
                                        });
                                        erwingoApp.ajax({
                                            data: {
                                                module: "erwingo",
                                                cl: "Backend",
                                                fnc: "getWidgets",
                                            },
                                            success: function (response) {
                                                var gridster = $(document).find("#widgets > ul");
                                                gridster.removeData('drag');
                                                gridster.data('gridster').destroy();
                                                gridster.empty().append(response);
                                                gridster.gridster(options.gridsterOption).data('gridster');
                                                erwingoApp.loadModules("#widgets");
                                            }
                                        });
                                        closedWidgets = {};
                                    }
                                });
                            }
                        }
                    }
                }
            }
            if (typeof key[label]['ajax'] !== 'undefined') {
                key[label]['callback'] = function () {
                    erwingoApp.ajax({
                        data: key[label]['ajax'],
                        success: function (response) {
                        }
                    });
                }
            }
            if (typeof key[[label]]['popup'] !== 'undefined') {
                key[label]['callback'] = function () {
                    $("<div></div>").window(key[label]['popup']);
                }
            }
            items = $.extend(items, key);
        });
        //console.log(items);
    }

    var state = true;
    $(document).keydown(function (e) {
        //enable or disable menu on keydown esc
        if (e.which == 27) {
            state = !state;
            if (!state) {
                $.contextMenu('destroy');
            } else {
                $.contextMenu(contextMenuOptions);
            }
        }
    });
};
erwingoApp.dynamicPopover = function ($elem) {
    if ($elem.data("popoverContent")) {
        return $elem.data("popoverContent");
    } else {
        // Prevent double call (bootstrap bug)
        if (!$elem.data("contentCalled")) {
            $elem.data("contentCalled", true);
            return " ";
        }
        var data = $elem.data(),
            id = "tmp-id-" + $.now();
        var reqData = {
            module: data.popoverModule || "",
            cl: data.popoverCl,
            fnc: data.popoverFnc,
        };
        // Add other data attributes
        $.each($elem.data(), function (k, v) {
            if (["cl", "fnc", "module", "popoverModule", "popoverCl", "popoverFnc", "popoverContent", "contentCalled"].indexOf(k) < 0 && typeof v == "string") {
                reqData[k] = v;
            }
        });
        erwingoApp.ajax({
            data: reqData,
            success: function (response) {
                $("#" + id).html(response);
                $elem.data("popoverContent", response);
                $elem.data("contentCalled", false);
                $elem.popover("reposition");
            }
        });
        return '<div id="' + id + '"><i class="fa fa-spinner fa-spin fa-2x fa-fw text-muted"</div>';
    }
};
erwingoApp.autologout = function () {
    var url = window.location.href;
    if (url.indexOf('autologout') == -1) {
        var qs = (url.indexOf('?')) > -1 ? '&autologout' : '?autologout';
        if (url.indexOf('#') > -1) {
            window.location.href = url.replace("#", qs + "#");
        } else {
            window.location.href = url + qs;
        }
    } else {
        window.location.reload();
    }
};


erwingoApp.showLoadingIndicator = function () {
  // increase counter as we got a new request
  erwingoApp.options.requestCount += 1

  $(".preloader").removeClass("d-none")
}


erwingoApp.hideLoadingIndicator = function (force = false) {
  // reduce counter as a request was finished
  erwingoApp.options.requestCount -= 1

  // only hide loading indicator if no more requests are running
  if (erwingoApp.options.requestCount <= 0 || force === true) {
    erwingoApp.options.requestCount = 0
    $(".preloader").addClass("d-none")
  }
}


erwingoApp.loadingIndicatorUpdateProgress = function(width = 0, text = '0 %') {
    if (width === null || width === undefined || width === '' || width < 0) {
      $('.preloader .progress').addClass("d-none")
      $('.preloader .spinner').css('height', '160px')
    } else {
      $('.preloader .spinner').css('height', '200px')
      $('.preloader .progress').removeClass("d-none")

      $('.preloader .progress .progress-bar')
        .css('width', Math.min(100, width) + '%')
        .text(text)
    }
}


erwingoApp.getAffectedCheckboxes = function(queryId) {
    const domQuery = `#${queryId}ScrollTable input:not([disabled]):checkbox`
    const availableForCheck = $(domQuery).length
    const participants = erwingoApp.getDisabledCheckboxesCount(queryId)
    const checked = $(domQuery + ':checked').length

    if (availableForCheck === checked && availableForCheck !== 0) {
        $(`input[name="${queryId}checkall"]`).prop('checked', true)
    }
    else {
        $(`input[name="${queryId}checkall"]`).prop('checked', false)
    }

    $(`#${queryId}newAffected`).text(checked)
    $(`#${queryId}totalAffected`).text(participants + checked)
}


erwingoApp.getDisabledCheckboxesCount = function(queryId) {
    return $(`#${queryId}ScrollTable input:checkbox:disabled`).length
}

$(document).on("click",".change-language",function() {
    localStorage.setItem('locale', this.id);
});


erwingoApp.downloadBlob = function(data) {
    if (!data) {
        return;
    }

    let contentType, filename, base64Data;

    // try to determine format of json response by delimiter
    if (data.split('\r\n\r\n').length > 1) {
        // extract base64 data
        const base64Parts = data.split('\r\n\r\n');
        const base64Head = base64Parts[0];
        base64Data = base64Parts[1];

        // try to fetch content type from head information
        const contentTypeRegex = /Content-Type:\s*([^;]+)/i;
        const contentTypeMatch = base64Head.match(contentTypeRegex);
        if (contentTypeMatch && contentTypeMatch[1]) {
            contentType = contentTypeMatch[1].trim();
        } else {
            console.error("[downloadBlob] Content-Type could not be retrieved!");
            alert("FEHLER: Die Datei konnte leider nicht heruntergeladen werden!");
            return;
        }

        // try to fetch filename from head information
        const filenameRegex = /filename\s*=\s*"([^"]+)"/i;
        const filenameMatch = base64Head.match(filenameRegex);
        if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].trim();
        } else {
            console.error("[downloadBlob] Filename could not be retrieved!");
            alert("FEHLER: Die Datei konnte leider nicht heruntergeladen werden!");
            return;
        }
    } else if(data.split(';').length > 1) {
        [contentType, filename, base64Data] = data.split(';', 3);
    } else {
        console.error("[downloadBlob] Could not download file!");
        alert("FEHLER: Die Datei konnte leider nicht heruntergeladen werden!");
        return;
    }

    // decode to binary data and create blob
    let binaryData = atob(base64Data);

    // convert to array buffer
    let arrayBuffer = new ArrayBuffer(binaryData.length);
    let uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
    }

    // create the blob
    let blob = new Blob([arrayBuffer], { type: contentType });

    // create temp url to download the file
    let url = URL.createObjectURL(blob);

    // download the file
    let dlLink = document.createElement('a');
    dlLink.href = url;
    dlLink.download = filename;
    document.body.appendChild(dlLink);
    dlLink.click();

    // clean up
    document.body.removeChild(dlLink);
    URL.revokeObjectURL(url);
}

// helper method to wait until an element was added to the DOM
erwingoApp.waitForElement = function(selector, callback) {
    let observer = new MutationObserver(() => {
        let element = $(selector);
        if (element.length) {
            observer.disconnect();
            callback(element);
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
}


// debounce function to limit event frequency
erwingoApp.debounce = function(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
